import {
  Alert,
  AlertIcon,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Stack,
  useToast,
} from '@chakra-ui/react';
import SOPSResource from 'api/sops';
import SOPSForm from 'components/sops/SOPSForm';
import { strings } from 'config/localization';
import routes from 'constants/routes';
import { SOPSSchema } from 'constants/schema';
import React, { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { Link as RouterLink, useHistory } from 'react-router-dom';

const CreateSOPS: React.FC = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const form = useRef() as React.MutableRefObject<HTMLFormElement>;
  const history = useHistory();
  const methods = useForm<SOPSSchema>();
  const sopsAPI = new SOPSResource();

  const [errorMessage, setErrorMessage] = useState<SOPSSchema>();

  const addUser = useMutation((data: any) => sopsAPI.store(data), {
    onSuccess: (res: any) => {
      toast({
        title: strings.sop_success_msg,
        description: res.data.email,
        status: 'success',
        isClosable: true,
      });
      queryClient.invalidateQueries('sopsList');
      history.push(routes.sops.list);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.errors);
    },
  });

  const onSubmit = (data: any) => {
    const formData = {
      company_id: data.company_id.value,
      work_type_id: data.work_type_id.value,
      sop_link: data.sop_link,
    };
    addUser.mutate(formData);
  };

  return (
    <Stack direction="column" spacing="4">
      <Breadcrumb color="gray.400" size="4">
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to={routes.sops.list}>
            {strings.sops}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage color="gray.900">
          <BreadcrumbLink>{strings.add_sops}</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Flex justify="space-between">
        <Heading size="md">{strings.add_new_sops}</Heading>
      </Flex>

      <Box bg="white" p={['3', '6']} shadow="box" rounded="sm">
        <FormProvider {...methods}>
          <form ref={form} onSubmit={methods.handleSubmit(onSubmit)}>
            <Stack direction="column" spacing="4">
              {addUser.isError && (
                <Alert status="error">
                  <AlertIcon />
                  {strings.sops_creation_failed}
                </Alert>
              )}
              <SOPSForm />
              <ButtonGroup>
                <Button
                  colorScheme="primary"
                  type="submit"
                  isLoading={addUser.isLoading}>
                  {strings.add_sops}
                </Button>
                <Button variant="outline" onClick={() => history.goBack()}>
                  {strings.cancel}
                </Button>
              </ButtonGroup>
            </Stack>
          </form>
        </FormProvider>
      </Box>
    </Stack>
  );
};

export default CreateSOPS;
